import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { GovernoratesService } from '../../../../services/governorates.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-deliveryareasprices',
  templateUrl: './deliveryareasprices.component.html',
  styleUrls: ['./deliveryareasprices.component.scss']
})
export class DeliveryareaspricesComponent implements OnInit {
  allData: any[] = [];
  displayedColumns: string[] = ["governorate", "price"];
  dataSource: MatTableDataSource<any>;

  contentReady: boolean = true;
  noData: boolean = false;
  isAr: boolean = localStorage.getItem("language") === "ar";
 isMobile!: boolean;
  // فورم إضافة السعر
  priceForm!: FormGroup;
  governorates: any[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
        private deviceService: DeviceDetectorService,
        private router: Router,
    private governoratesService: GovernoratesService,
    private fb: FormBuilder
  ) {
    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
          this.isMobile = this.deviceService.isMobileDevice();
    if (this.isMobile)
      this.router.navigateByUrl('/deliveryfees.mobile');
    this.loadGovernoratePrices();
    this.initForm();
    this.loadGovernorates();
  }

  // ✅ تهيئة الفورم
  initForm() {
    this.priceForm = this.fb.group({
      governorate_id: ['', Validators.required],
      price: ['', [Validators.required, Validators.min(0)]],
    });
  }

  // ✅ تحميل المحافظات
  loadGovernorates() {
    this.governoratesService.getAllGovernorates().subscribe({
      next: (data) => (this.governorates = data),
      error: (err) => console.error(err),
    });
  }

  // ✅ تحميل الأسعار على مستوى المحافظة
  loadGovernoratePrices(): void {
    this.contentReady = true;
    this.governoratesService.getAllGovernoratePrices().subscribe({
      next: (data) => {
        this.allData = data;
        this.dataSource = new MatTableDataSource(this.allData);
        this.dataSource.paginator = this.paginator;
        this.contentReady = false;
        this.noData = this.allData.length === 0;
      },
      error: (err) => console.error(err),
    });
  }

  // ✅ إضافة
  addItem(): void {
    if (this.priceForm.invalid) return;

    this.governoratesService.createGovernoratePrice(this.priceForm.value).subscribe({
      next: () => {
        this.loadGovernoratePrices();
        this.priceForm.reset();
        Swal.fire("تمت الإضافة", "", "success");
      },
      error: (err) => console.error(err),
    });
  }




}
